// extracted by mini-css-extract-plugin
export default {"buttons":"Confirmation_buttons__v9cAK","title":"Confirmation_title__3RCm2"};